import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import {getStudentIdData } from "../../../lib/studentappcheckview"
import {updateData ,addData} from "../../../lib/studentappcheck"
import {useAuth} from "../../../usercontext";

export default function StudentAppCheckList() {
    const [booklist, setBookList] = useState([]);
    const { profile } = useAuth();

    //const slug = "6cd022a6-81d9-4aba-8487-fd34f1ffd4c9";
    const slug =  profile.id;

    async function UpdateIsRead(Id,isCheck,appid) {

      //console.log("Add",Id,isCheck,appid);
     

      if (isCheck !== null)
      isCheck = true
      else
      isCheck = false;

      //Id doesnt exist you have to add
      if(Id === null)  
      {
        console.log("Add",Id,isCheck,appid);
        await addData({
          isCheck : !isCheck,
          studentId : slug,
          appcheckId : appid
        });

      }
      else
      {
        console.log("Update",Id,isCheck,appid);
        await updateData({
          id: parseInt(Id),
          isCheck : !isCheck
        });

      }
      GetData() ;
      }


function ChangeStatus(Id, isCheck,appid) {
    //console.log("Id",Id,isRead);
/*
    const myNextList = [...booklist];
    const artwork = myNextList.find(
      a => a.id === Id
    );
    artwork.isCheck = !artwork.isCheck;
    console.log("myNextList",myNextList);
    setBookList(myNextList);
*/
    UpdateIsRead(Id, isCheck,appid);
}

    async function GetData() {
        const books = await getStudentIdData(slug);
        setBookList(books);
        console.log("books",books);
      }
    
    useEffect(() => {
      GetData();
    }, [profile]);

    return (
                <div className="col-12">
                  <div className="settings-widget profile-details">
                    <div className="settings-inner-blk p-0">
                      <div className="profile-heading">
                        <h3>Book List</h3>
                      </div>
                      <div className="comman-space pb-0">
                        <div className="settings-invoice-blk table-responsive">
                          {/* Invoice info */}
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>Id</th>
                                <th>Category</th>
                                <th>Question</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                            {booklist.map(function (data) {
                              return (
                                <tr key={data.appid}>
                                <td>
                                  <Link
                                    to="#"
                                    className="invoice-no"
                                  >
                                  {data.appid}
                                  </Link>
                                </td>
                                <td>{data.pname}</td>
                                <td>{data.question}</td>
                                <td><div className="form-check form-switch check-on">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={data.isCheck}
                                onChange={(e) => ChangeStatus(data.id,data.isCheck,data.appid)}
                              />
                            </div></td>

                              </tr>
                              )
                            })}
                            </tbody>
                          </table>
                          {/* Invoice info */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
      );
    }